import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EndorsementService } from '../service/endorsement/endorsement.service';
import { RiplayUmumModel } from '../riplay-umum/shared/riplay-umum.model';
import { LoginModel } from '../login/shared/login.model';
import { DashboardService } from '../service/dashboard/dashboard.service';
import { DraftService } from '../service/save-draft/save-draft.service';

@Component({
  selector: 'app-endorse-name-app-no',
  templateUrl: './endorse-name-app-no.component.html',
  styleUrls: ['./endorse-name-app-no.component.css'],
})
export class EndorseNameAppNoComponent {
  login: LoginModel = {};
  summary: any = {};
  nameAppNoForm: FormGroup;
  productInfo: RiplayUmumModel = {};
  dataPribadi: any = {};
  public selectedItem: any;
  isInputReadonly: boolean = false;
  tandaTangan: any;
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dashboardService: DashboardService,
    private formBuilder: FormBuilder,
    private draftService: DraftService
  ) {
    let background = document.getElementById('background');
    if (background != null) {
      background.className = 'allianz-background-faded';
    }

    let jsonSelectedItem = localStorage.getItem('selected-item');
    if (jsonSelectedItem) {
      this.selectedItem = JSON.parse(jsonSelectedItem);
    }
    
    let jsonLogin = sessionStorage.getItem('login');
    if (jsonLogin) {
      this.login = JSON.parse(jsonLogin);
    }

    let jsonSummary = localStorage.getItem('summary');
    if (jsonSummary) {
      this.summary = JSON.parse(jsonSummary);
    }
    console.log('summary ', this.summary);

    this.nameAppNoForm = formBuilder.group({
      nama: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      appNo: ['', [Validators.required]],
    });

    let jsonProduct = localStorage.getItem('selected-product');
    if (jsonProduct != null) {
      this.productInfo = JSON.parse(jsonProduct);
    }

    let jsonDataPribadi = localStorage.getItem('data-pribadi');
    if (jsonDataPribadi != null) {
      this.dataPribadi = JSON.parse(jsonDataPribadi);
    }

    localStorage.setItem('from-endorse-name-app-no', 'true')
  }

  continue() {
    if (this.nameAppNoForm.valid) {
      this.isLoading = true;

      this.getDraftCover1();
      this.getDraftCover2();
      this.getDraftCover3();
      this.getNasabah();
    }
  }

  back() {
    this.router.navigate([
      '/eform/dashboard/insured-summary/' +
        this.selectedItem.referenceNo +
        '/' +
        this.login.partnerId,
    ]);
  }

  getNasabah() {
    this.dashboardService
      .getNasabah(this.selectedItem.referenceNo!)
      .subscribe((res) => {
       localStorage.setItem('from-dashboard', 'true');
        localStorage.setItem('nasabah', JSON.stringify(res));

        this.router.navigate(['eform/spajk-riplay-bsi']);
        this.isLoading = false;
      });
  }

  getDraftCover1() {
    this.draftService
      .getDraft({
        userId: this.login.userid,
        pageId: 'draftCover1',
        partnerId: this.login.partnerId,
        productCode: this.selectedItem.productCode,
        referenceNo: this.selectedItem.referenceNo,
      })
      .subscribe((res) => {
        console.log('res DRAFT1', res);
        if (res.statusId == 1) {
          localStorage.setItem(
            'data-pribadi',
            JSON.stringify({
              nik: res.identityNo,
              namaLengkap: this.nameAppNoForm.value.nama,
              namaAlias: res.allias,
              statusPerkawinan: res.maritalStatus,
              tempatLahir: res.pob,
              nomorAplikasi: this.nameAppNoForm.value.appNo,
              usia: res.entryAge,
              jenisKelamin: res.gender,
              kantorCabang: res.branchName + '-' + res.branchCode,
            })
          );
        }
      });
  }

  getDraftCover2() {
    this.draftService
      .getDraft({
        userId: this.login.userid,
        pageId: 'draftCover2',
        partnerId: this.login.partnerId,
        productCode: this.selectedItem.productCode,
        referenceNo: this.selectedItem.referenceNo,
      })
      .subscribe((res) => {
        if (res.statusId == 1) {
          localStorage.setItem(
            'kontak-pribadi',
            JSON.stringify({
              nomorHPPribadi: res.mobilePhoneNo,
              emailPribadi: res.emailAddress,
              alamatPribadi: res.address,
              kodePosPribadi: res.zipcode,
              provinsiPribadi: res.province,
              kotaPribadi: res.city,
              alamatDomisili: res.addressDomicile,
              kodePosDomisili: res.zipcodeDomicile,
              provinsiDomisili: res.provinceDomicile,
              kotaDomisili: res.cityDomicile,
            })
          );
        }
      });
  }

  getDraftCover3() {
    this.draftService
      .getDraft({
        userId: this.login.userid,
        pageId: 'draftCover3',
        partnerId: this.login.partnerId,
        productCode: this.selectedItem.productCode,
        referenceNo: this.selectedItem.referenceNo,
      })
      .subscribe((res) => {
        if (res.statusId == 1) {
          this.tandaTangan = {
            tempatTandaTangan: res.ttdTempat,
            ttdSales: res.ttdSales,
            ttdCandidate: res.ttdCandidate,
          };
          localStorage.setItem(
            'kontak-kantor',
            JSON.stringify({
              namaKantor: res.companyName,
              alamatKantor: res.officeAddress,
              kodePosKantor: res.officeZipCode,
              provinsiKantor: res.officeProvince,
              kotaKantor: res.officeCity,
            })
          );
          localStorage.setItem(
            'tanda-tangan',
            JSON.stringify(this.tandaTangan)
          );
        }
      });
  }
}
